import ButtonOutlined from '@components/buttos/button-outlined';
import ModalComponet from '@components/modal';
import { BasicVideoCallI, IJoinArgs, VideoCallReciveI } from '@interfaces/videocall/videocall';
import Lobby from '@fc/videocall/Lobby/lobby';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@redux/store';
import { setVideoCallCameraControl, setVideoCallInProcess, setVideoCallMuteControl } from '@redux/slices/video-call/videoCall-alert.slice';
import { createVideoCallStartData } from '@services/videocall/videoCallService';
import { setAnswered } from '@redux/slices/video-call/video-call.slice';

interface VideoAlertProps {
    open: boolean,
    reciveCall: () => void
    declineCall: () => void
    callInProsess: boolean
    videoCall: VideoCallReciveI | undefined
    leaveUser?: BasicVideoCallI
}

const VideoAlert = (props: VideoAlertProps) => {
    const {open, reciveCall, declineCall, callInProsess, videoCall, leaveUser} = props;
    const session = useSelector((state: RootState) => state.session);
    const [mediaAccessDenied, setMediaAccessDenied] = useState(false);
    const [initialMediaAccess, setInitialMediaAccess] = useState<IJoinArgs>();
    const dispatch = useDispatch();

    const onJoin = async(args: IJoinArgs) => {
        console.debug("Change initial values", args);
        setInitialMediaAccess(args);
    }

    const acceptCall = () => {
        const roomId = videoCall?.room
        if(!roomId) return
        createVideoCallStartData(roomId)
            .then(status => {
                console.debug(`Create timer for room ${roomId}`, status)
                dispatch(setVideoCallInProcess({videoCallInProgress: true}))
                dispatch(setVideoCallMuteControl({muteControl: initialMediaAccess?.audio || false}))
                dispatch(setVideoCallCameraControl({cameraControl: initialMediaAccess?.video || false}))
                dispatch(setAnswered(true))

                reciveCall();
            })
            .catch(err => console.error("Could not create videocall timer", err))
    }

    return (
        <ModalComponet
            open={open}
            onClose={() => null}
        >
            <div className="Callcard__Video">
                <div className="Callcard__TitleContainer">
                    <p className="Callcard__Title">
                        {leaveUser ? 'Video llamada terminada' : !callInProsess ? 'Video llamada de voz entrante' : <span className="Callcard__Title-Green">Video llamada en proceso</span>}
                    </p>
                    <p className="Callcard__Text">
                        Paciente: <strong>{videoCall?.nameEmit}</strong> {leaveUser ? 'Ha abandonado la llamada' : ''}
                    </p>
                </div>
                <Lobby 
                    canUseStream={(value) => setMediaAccessDenied(!value)}
                    join={onJoin}
                    onMediaEnabledChange={onJoin}
                    showButton={false}
                    username={session.username ?? ""}
                />
                <div className="Callcard__ButtonsContainer">
                    {!callInProsess && !leaveUser ?
                        <ButtonOutlined
                            label={'Rechazar'}
                            icon={'fas fa-phone-hangup'}
                            action={declineCall}
                        />
                    : null}
                    {!callInProsess && !leaveUser && !mediaAccessDenied ?
                        <ButtonOutlined
                            label={'Aceptar'}
                            icon={'fas fa-video'}
                            style={{backgroundColor: '#58CF09'}}
                            action={acceptCall}
                        />
                    : !mediaAccessDenied ?
                        <ButtonOutlined
                            label={'Terminar video llamada'}
                            icon={'fa fa-phone-hangup'}
                            action={declineCall}
                        />
                    :
                        <div></div>
                    }
                </div>
            </div>
        </ModalComponet>
    );
}

export default VideoAlert
